import React from "react";
import "./ContactModal.css"; // Archivo CSS para los estilos

const ContactModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()} // Evita cerrar el modal al hacer clic dentro
      >
        <button className="close-btn" onClick={onClose}>
          &times;
        </button>
        <h2>Contáctanos</h2>
        <form>
          <input type="text" placeholder="Nombre" required />
          <input type="email" placeholder="Correo electrónico" required />
          <textarea placeholder="Escribe tu mensaje" rows="5" required></textarea>
          <button type="submit" className="submit-btn">
            Enviar
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactModal;
